module.exports = self.fetch || (self.fetch = require('unfetch').default || require('unfetch'));



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-unfetch/browser.js
// module id = 3022
// module chunks = 0